<!-- 其他产品质量评价维护 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="queryData"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <!-- 创建方式 -->
      <div class="handle-wrapper">
        <eui-btn font-size="12px" type="secondary" @click="openDialog('新增', null)">新增</eui-btn>
        <eui-btn type="secondary" font-size="12px" @click="handleDelete(null)">删除</eui-btn>
      </div>
      <!-- table @handleSelectAll="handleSelectAll"    -->
      <e-table-list
        ref="multipleTable"
        :row-key="'purchaseDemandItemId'"
        :table-data="tableData"
        :table-label="tableLabel"
        :selection-show="true"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #index="{ scope }">
          <span>
            {{ (queryData.pageNum - 1) * queryData.pageSize + scope.$index + 1 }}
          </span>
        </template>
        <template #operation="{ scope: { row } }">
          <eui-link lighten font-size="12px" @click="openDialog('查看', row)">查看</eui-link>
          <eui-link lighten font-size="12px" style="margin-left: 10px" @click="openDialog('修改', row)">修改</eui-link>
          <eui-link lighten font-size="12px" style="margin-left: 10px" @click="handleDelete(row)">删除</eui-link>
        </template>
      </e-table-list>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="total"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <TheDialog
      v-if="dialogVisible"
      :id="id"
      :dialog-visible.sync="dialogVisible"
      :dialog-title="dialogTitle"
      @refresh="getList()"
    ></TheDialog>
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import Api from '@/modules/projectA/api/ESorganization';
import pApi from '@/modules/projectA/api/product';
import TheDialog from './components/thenDiaolg.vue';

export default {
  components: {
    eSearch,
    eTableList,
    TheDialog,
  },
  data() {
    return {
      tableData: [],
      tableSelectData: [],
      total: 0,
      tableLabel: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          width: '100',
          slot: 'index',
        },
        {
          label: '供应商名称',
          param: 'companyName',
          align: 'center',
          minWidth: '140',
          tooltip: true,
        },
        {
          label: 'EQE编码',
          param: 'evaluationCode',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '产品名称',
          param: 'productName',
          align: 'center',
          minWidth: '160',
          tooltip: true,
        },
        {
          label: '证书编号',
          param: 'certificateNo',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '评价等级',
          align: 'center',
          param: 'scoreLevel',
          minWidth: '190',
        },
        {
          label: '综合得分',
          param: 'score',
          align: 'center',
          minWidth: '170',
        },
        {
          label: '报告到期日',
          param: 'deadline',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '证书状态',
          param: 'certificateStatus',
          render(row) {
            if (row.certificateStatus === '1') {
              return '有效';
            }
            if (row.certificateStatus === '2') {
              return '过期';
            }
            return '';
          },
          align: 'center',
          minWidth: '170',
        },
        {
          label: '更新时间',
          param: 'editTime',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '操作',
          align: 'center',
          minWidth: '160',
          slot: 'operation',
          fixed: 'right',
        },
      ],
      queryData: {
        companyName: '',
        evaluationCode: '',
        productName: '',
        certificateStatus: '',
        pageNum: 1,
        pageSize: 10,
      },
      fieldList: [
        /* {
          label: '供应商',
          type: 'select',
          value: 'shieldCompanyId',
          list: 'shieldCompanyNameList',
          filterable: true,
          remote: true,
          reserveKeyword: true,
          loading: this.selectLoading,
          clearable: true,
          companyName: true,
          remoteMethod: this.getShieldCompanyNames,
        }, */
        {
          label: '供应商',
          type: 'input',
          value: 'companyName',
        },
        {
          label: 'EQE编码',
          type: 'input',
          value: 'evaluationCode',
        },
        { label: '产品名称', type: 'input', value: 'productName' },
        { label: '证书状态', type: 'select', value: 'certificateStatus', list: 'certificateStatus' },
      ],
      listTypeInfo: {
        certificateStatus: [
          { id: '', name: '全部' },
          { id: 1, name: '有效' },
          { id: 2, name: '过期' },
        ],
      },
      dialogVisible: false,
      dialogTitle: '',
      id: -1,
    };
  },
  mounted() {
    this.getList();
  },

  methods: {
    // 通过映射关系进行映射转换
    changSelectKey(keyMap, query) {
      const newArr = query;
      newArr.map((item, index) => {
        const obj = newArr[index];
        for (const key in obj) {
          // key => companyName
          const newkey = keyMap[key];
          if (newkey) {
            // obj['name'] = obj['companyName']
            obj[newkey] = obj[key];
            //  删除原来的key 但是里面的旧key 如果没有映射就删除不了
            // delete obj[key];
          }
          // 删除原来的key 只保留映射关系后的key
          delete obj[key];
        }
      });
      console.log(newArr);
      return newArr;
    },
    // 获取供应商
    async getShieldCompanyNames(row) {
      if (row !== '') {
        this.selectLoading = true;
        const params = {
          pageSize: 20,
          pageNum: 1,
          companyName: row,
        };
        const res = await pApi.querySupplier(params);
        if (res.code === '200') {
          this.selectLoading = false;

          // 映射关系
          const keyMap = {
            companyName: 'name',
            companyId: 'id',
          };

          const arr = this.changSelectKey(keyMap, res.data.records);
          this.listTypeInfo.shieldCompanyNameList = [...arr];
        }
      } else {
        this.listTypeInfo.shieldCompanyNameList = [];
      }
    },
    // 查询采购计划列表-分页查询
    async getList() {
      const params = { ...this.queryData };
      const res = await Api.queryPageEvaluation(params);
      if (res.code === '200') {
        this.tableData = res.data.records;
        this.total = res.data.total;
      }
    },

    // 修改/查看/新增
    openDialog(title, row) {
      if (row) {
        this.id = row.id;
      }

      this.dialogTitle = title;
      this.dialogVisible = true;
    },
    // 批量删除
    async batchDeleteEvaluation(ids) {
      this.$confirm('确认删除后，报告将从系统重删除。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await Api.batchDeleteEvaluation(ids);
          if (res.code === '200') {
            this.$message.success('删除成功');
            this.handleReset();
            this.$refs.multipleTable.handleClearSelection();
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 单个删除
    delete(params) {
      this.$confirm('确认删除后，报告将从系统重删除。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          Api.deleteEvaluation(params).then((result) => {
            if (result.code === '200') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.handleReset();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },

    handleDelete(row) {
      if (!row) {
        // 多个
        if (this.tableSelectData.length === 0) {
          this.$message.warning('请选择数据');
          return;
        }
        const ids = this.tableSelectData.map((item) => item.id);
        this.batchDeleteEvaluation(ids);
      } else {
        const { id = '' } = row;
        // 单个
        this.delete({ id });
      }
    },

    // table批量选择
    handleSelectionChange(list) {
      console.log(list);
      this.tableSelectData = list;
    },
    // 全选框
    handleSelectAll(list) {
      this.tableSelectData = list;
    },

    // 查询
    handleFilter(val) {
      this.queryData = val;
      this.queryData.pageNum = 1;
      this.queryData.startTime = val.createTime ? val.createTime[0] : '';
      this.queryData.endTime = val.createTime ? val.createTime[1] : '';
      this.getList();
    },
    // 重置
    handleReset() {
      this.queryData = this.$options.data().queryData;
      this.getList();
    },
    // 分页
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  padding: 10px 20px 10px 36px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin-bottom: 20px;
}

::v-deep .el-table {
  th.el-table__cell > .cell {
    font-weight: normal;
    font-size: 14px;
  }
}
.btn-main-more {
  display: inline-block;
  margin-right: 10px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #2587ff;
  -webkit-user-select: none;
  border-radius: 0px;
  cursor: pointer;
  &:hover {
    background: #126edf;
  }
}
.pagination-box {
  text-align: right;
}
</style>
